{
    "PartitionList_Column_Description": "Beschrijving",
    "PartitionList_Column_IDInTelSys": "ID",
    "PartitionList_Column_Licence": "Licentie",
    "PartitionList_Column_Extensions": "Uitbreidingen",
    "PartitionList_Column_AcdAgents": "Agenten",
    "PartitionList_Column_AppUsers": "Gebruikers",
    "PartitionList_Column_SyncType": "Synchronisatietype",
    "PartitionList_Column_Status": "Status",
    "PartitionList_Filter_Licence": "Licentie",
    "PartitionList_CountLink_ExtensionsAria": "Bekijk de apparaten in deze partitie.",
    "PartitionList_CountLink_AcdAgentsAria": "Bekijk ACD-agents in deze partitie",
    "PartitionList_CountLink_AppUsersAria": "Bekijk de app-gebruikers in deze partitie.",
    "PartitionList_Add_Disabled_SelectTelephonyServer": "Selecteer een telefonieserver om een ​​partitie toe te voegen.",
    "NAME": "PartitionListLanguage"
}